import { getLang } from "@app/dashboard/utils/localStorageUtils";
import type { IHomeApisParams } from "@app/dashboard/types/innerLayout/home";
import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

const genericHeaders = {
  "Accept-Language": getLang()
};

const generateQueryParams = (params: IHomeApisParams, compare: boolean = true) => {
  let queryParams: IHomeApisParams = {
    start_date: params.start_date,
    end_date: params.end_date,
    channel: params.channel,
    currency: params.currency,
    is_live: params.is_live
  };

  if (compare) {
    queryParams = {
      ...queryParams,
      compare: true,
      compare_start_date: params.compare_start_date,
      compare_end_date: params.compare_end_date,
      res_type: params.res_type
    }
  } else {
    queryParams = {
      ...queryParams,
      compare: false,
    }
  }

  return queryParams;
};


export const getTotalSales = (params: IHomeApisParams) => {
  const queryParams = generateQueryParams(params);

  return axiosPrivate.get(`/dashboard/graphs/gross_volume`, { headers: {...genericHeaders}, params: { ...queryParams } });
};

export const getNetSales = (params: IHomeApisParams) => {
  const queryParams = generateQueryParams(params);

  return axiosPrivate.get(`/dashboard/graphs/net_volume`, { headers: {...genericHeaders}, params: { ...queryParams } });
};

export const getMethodsUsage = (params: IHomeApisParams) => {
  const queryParams = generateQueryParams(params);

  return axiosPrivate.get(`/dashboard/graphs/paymethods`, { headers: {...genericHeaders}, params: { ...queryParams } });
};

export const getTerminalsRevenue = (params: IHomeApisParams) => {
  const queryParams = generateQueryParams(params);

  return axiosPrivate.get(`/dashboard/graphs/pos_branches`, { headers: {...genericHeaders}, params: { ...queryParams } });
};

export const getFailureReasons = (params: IHomeApisParams) => {
  const queryParams = generateQueryParams(params, false);

  return axiosPrivate.get(`/dashboard/graphs/failure_reasons`, { headers: {...genericHeaders}, params: { ...queryParams } });
};

export const getPerformanceHighlights = (params: IHomeApisParams) => {
  const queryParams = generateQueryParams(params);

  return axiosPrivate.get(`/dashboard/graphs/performance`, { headers: {...genericHeaders}, params: { ...queryParams } });
};